import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../data/services";

export default function WhatsAppButton() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar por WhatsApp"
      data-testid="whatsapp-floating-btn"
      className="fixed bottom-20 right-6 z-40 flex items-center gap-3 bg-[#25D366] hover:bg-[#1FB755] text-white pl-4 pr-5 py-3 rounded-full shadow-xl transition-all hover:scale-105 group"
      style={{ boxShadow: "0 12px 32px -8px rgba(37, 211, 102, 0.45)" }}
    >
      <MessageCircle size={20} className="group-hover:rotate-12 transition-transform" />
      <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
    </a>
  );
}